// Timing constants (in milliseconds)
export const DEBOUNCE_DELAY_MS = 300;
export const OUTSIDE_CLICK_LISTENER_DELAY_MS = 100;
export const CALENDAR_MOVE_DELAY_MS = 50;

// Calendar & Pagination
export const INITIAL_CALENDAR_MONTHS = 2;
export const DESKTOP_MONTHS_TO_FETCH = 2;
export const MOBILE_MONTHS_TO_FETCH = 1;
export const INFINITE_SCROLL_DISTANCE_PX = 10;

// Sessions display
export const SESSIONS_PAGE_SIZE = 6;
export const HOURS_IN_DAY = 24;
export const MS_PER_HOUR = 1000 * 60 * 60;

// Icon sizes
export const ICON_SIZE_SM = 16;
export const ICON_SIZE_MD = 20;
export const ICON_SIZE_LG = 32;
export const ICON_SIZE_XL = 48;
